if (!customElements.get('product-form')) {
  customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();

          this.form = this.querySelector('form');
          this.form.querySelector('[name=id]').disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');

          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

          this.hideErrors = this.dataset.hideErrors === 'true';
        }

        onSubmitHandler(evt) {
          evt.preventDefault();
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

          this.handleErrorMessage();

          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);

          // Check if 'Custom' is selected and add the custom amount to cart properties
const selectedVariant = this.form.querySelector("[name=id] option:checked");
if (selectedVariant && selectedVariant.text.trim() === "Custom") {
  const customAmountInput = document.querySelector("#custom-amount");
  if (customAmountInput && customAmountInput.value) {
    formData.append("properties[Custom Amount]", customAmountInput.value);
  }
}

          if (this.cart) {
            formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          if (evt?.submitter?.dataset?.role == 'personaliser-add') {
            formData.append('properties[_personalisation]', true);
            // Get the engraving note
    const noteInput = document.querySelector('#Engraving-Note');
    if (noteInput) {
        formData.append('properties[_engraving_note]', noteInput.value.trim());
    }


              function humanReadable(property) {
                  return property.split('_').map((str) => str[0].toUpperCase() + str.slice(1).toLowerCase()).join(' ')
              }

              for(const value of formData.entries()){
                if (/properties\[\_personalised_/.test(value[0])) {
                  const matches = value[0].match(/properties\[\_personalised_([A-Z_]+)\]/)
                  formData.append('properties[' + humanReadable(matches[1]) + ']', value[1])
                }
              }
            const inputElements = document.querySelectorAll(".product-popup-modal__content-info input, .product-popup-modal__content-info select");

            for (let i = 0, max = inputElements.length; i < max; i++) { // loop through input elements and make value ''
                inputElements[i].value = ''
            }
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    errors: response.errors || response.description,
                    message: response.message,
                  });
                  this.handleErrorMessage(response.description);

                  const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute('aria-disabled', true);
                  this.submitButton.querySelector('span').classList.add('hidden');
                  soldOutMessage.classList.remove('hidden');
                  this.error = true;
                  return;
                } else if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }

                if (!this.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    cartData: response,
                  });
                this.error = false;
                const quickAddModal = this.closest('quick-add-modal') || this.closest('personaliser-modal');
                if (quickAddModal) {
                  document.body.addEventListener(
                      'modalClosed',
                      () => {
                        setTimeout(() => {
                          this.cart.renderContents(response);
                        });
                      },
                      { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(response);
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading__spinner').classList.add('hidden');
              });
        }

        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;

          this.errorMessageWrapper =
              this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
  );
}

